import { trackPromise } from 'react-promise-tracker';
import constants from './constants';
import {orderIdCardForUserService} from '../../services/orderIdCardService';

export const orderIdCardBegin = () => ({
    type: constants.ORDER_ID_CARD_BEGIN
});
export const orderIdCardSuccess = (data) => ({
    type: constants.ORDER_ID_CARD_SUCCESS,
    payload: { data }
});

export const orderIdCardCleanUp = () => ({
    type: constants.ORDER_ID_CARD_CLEANUP
});

export const orderIdCardError = (error) => ({
    type: constants.ORDER_ID_CARD_ERROR,
    payload: { error }
});

export const orderIdCard = (memberAccounts, tenantId, mailingAddress) => {
    return (dispatch) => {
        dispatch(orderIdCardBegin());
        const results = memberAccounts.map(memberAccount => orderIdCardForUserService(mailingAddress, tenantId, memberAccount));
        trackPromise(Promise.all(results).then((response) => {
            const data = response.map((res) => res?.data);
            dispatch(orderIdCardSuccess(data));
        }).catch((error) => {
            dispatch(orderIdCardError(error));
        }));
    };
};